module.exports = __webpack_public_path__ + "3d935afeeeb01e457d143814cafbd066.woff2";